// Components/WarningModal.js
import React from "react";
import { Link } from "react-router-dom";

export default function WarningModal({
  accepted,
  onAcceptedChange,
  onAcknowledge,
  requiresAcceptance,
}) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-lg w-full text-center">
        <h2 className="text-xl font-bold text-red-600 mb-4">
          ⚠️ Law Enforcement Use Only
        </h2>

        <p className="text-gray-700 mb-4 text-left">
          This application is provided exclusively for use by{" "}
          <strong>sworn law enforcement officers and other law enforcement professionals</strong>.
          It is intended to support professional collaboration, information sharing,
          and communication among those serving in law enforcement.
        </p>

        <div className="text-gray-700 text-left mb-4">
          <p className="font-bold text-red-700 bg-red-100 px-2 py-1 rounded">
            Access or use by individuals not affiliated with law enforcement is strictly prohibited.
          </p>
        </div>

        <p className="text-gray-700 font-medium mb-6 italic">
          “I confirm that I am a law enforcement professional and understand that this application
          is restricted to use within the law enforcement community.”
        </p>

        <div className="text-left mb-4">
          <label className="text-gray-700 text-sm flex items-start gap-2">
            <input
              type="checkbox"
              className="mt-1"
              checked={accepted}
              disabled={!requiresAcceptance}
              onChange={(e) => onAcceptedChange(e.target.checked)}
            />
            <span>
              I agree to the <Link to="/terms" className="text-blue-600 underline">Terms of Service</Link>{" "}
              and <Link to="/privacy-policy" className="text-blue-600 underline">Privacy Policy</Link>.
            </span>
          </label>
          <p className="text-sm text-gray-600 mt-2 font-semibold">
            By clicking “Acknowledge and Continue”, you confirm that you have read and understand
            the information above.
          </p>
        </div>

        <button
          onClick={onAcknowledge}
          disabled={!accepted}
          className={`w-full py-2 rounded-md transition duration-200 ${
            accepted
              ? "bg-blue-600 hover:bg-blue-700 text-white"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          Acknowledge and Continue
        </button>
      </div>
    </div>
  );
}
